import { Box, styled, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const PREFIX = 'SectionTitle';

const classes = {
  title: `${PREFIX}-tilte`,
  subtitle: `${PREFIX}-subtitle`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`& .${classes.title}`]: {
    marginBottom: theme.spacing(1),
  },
  [`& .${classes.subtitle}`]: {
    color: theme.palette.text.secondary,
  },
}));

const SectionTitle = ({
  title,
  marginBottom = 0,
  subtitle,
  subsection = false,
}) => {
  return !subsection ? (
    <StyledBox pb={marginBottom}>
      <Typography variant="h5" className={classes.title}>
        {title}
      </Typography>
      {subtitle ? (
        <Typography variant="body1" className={classes.subtitle}>
          {subtitle}
        </Typography>
      ) : null}
    </StyledBox>
  ) : (
    <StyledBox pb={marginBottom}>
      <Typography variant="subtitle1" color="textPrimary">
        {title}
      </Typography>
    </StyledBox>
  );
};

SectionTitle.propTypes = {
  title: PropTypes.string.isRequired,
  marginBottom: PropTypes.number,
};

export default SectionTitle;
